import React from "react";
import { useField } from "formik";
import PriceInput from "../PriceInput";

const FormPriceInput = ({ name, onChange = null, onBlur = null, ...rest }) => {
  const [field, meta] = useField(name);

  const getError = () => {
    if (!meta.touched || !meta.error) return null;
    if (Array.isArray(meta.error)) return meta.error.join(", ");
    return meta.error;
  };

  return (
    <PriceInput
      name={name}
      value={field.value}
      onChange={onChange ?? field.onChange}
      onBlur={onBlur ?? field.onBlur}
      error={getError()}
      {...rest}
    />
  );
};

export default FormPriceInput;
